import Row from "react-bootstrap/Row";
import styled from "styled-components";

export const StyledRowFooter = styled(Row)`
  background: #354052;
  color: #fff;
  .img-thumbnail {
    padding: 0.25rem;
    background-color: transparent !important;
    border: 1px solid transparent !important;
    border-radius: 0.25rem;
    max-width: 100%;
    height: auto;
}
  .col-container {
    padding: 3rem;
    @media (max-width: 600px) {
      padding-top: 3rem;
      padding-left: 0px;
      padding-right: 0px;
      text-align: center;
    }
  }
  .col-copy {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
    @media (max-width: 768px) {
      display: block
    }
  }
`;

export const StyledUlSocial = styled.ul`
  flex-direction: row;
  display: flex;
  list-style: none;
  padding: 0.25rem !important;
  margin: 0px;
  justify-content: flex-end;
  a {
    padding: 0.5rem !important;
  }

  img {
    width: 30px;
  }

  @media (max-width: 768px) {
    li {
      padding-right: 10px;
    }
  }
  @media (max-width: 500px) {
    justify-content: center;
    margin-top: 20px;
  }
`;

export const StyledSupport = styled.div`
  padding: 0.25rem !important;
  margin-top: 0px;
  margin-top: 6px;
  font-size: 12px;
  font-weight: bold;

  a {
    color: #fff;
  }
`;

export const StyledNewsletterContact = styled.div`
  padding: 0.25rem !important;
  margin-top: 0px;
  margin-top: 6px;
  font-size: 12px;
  font-weight: bold;

  button {
    background: white;
    border: 1px solid white;
    padding: 6px;
    padding-left: 9px;
    font-weight: bold;
    width: 55%;
    text-align: left;
    cursor: pointer;
    a {
      color: #000;
    }
    @media (max-width: 1024px) {
      width: 75%;
    }
  }
  span {
    background: #E63457;
    padding: 8px 8px 10px 8px;
  }

  a {
    color: #fff;
  }
`;

export const StyleCredits = styled.div`
  flex-direction: row;
  display: flex;
  list-style: none;
  padding: 0.25rem !important;
  margin: 0px;
  justify-content: center;
  align-items: center;

  @media (max-width: 500px) {
    justify-content: center;
  }
`;

export const StyleUlCredits = styled.div`
  font-size: 16px;
  text-align: center;
   li {
    line-height: 40px;
    list-style: none
  }

  @media (max-width: 500px) {
    margin-bottom: 0;
    columns: 1;
    li {
      font-size: 12px;
    }
  
  }
`;
